import type { Report } from '@/utils/types'
import { CustomDate, ISODate } from 'best-modules/utils'
import { getDirectory } from '@/directory'

const formatPeriod = (
  period: Report['period'],
  format: 'numeric' | 'locale' = 'numeric'
): string => {
  if (format === 'numeric') {
    const date: ISODate = `${period}-01`
    const formatedDate = new CustomDate(date).toString()

    return formatedDate.slice(3)
  }
  if (format === 'locale') {
    const [year, month] = period.split('-')

    const monthName =
      getDirectory('months', null, {
        type: 'collection',
      }).getItem(Number(month))?.name || month

    return `${monthName} ${year}`
  }

  return period
}

export { formatPeriod }
